var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{class:_vm.style},[_vm._v(_vm._s(_vm.formatTimeDelta(_vm.timeDelta)))])
}
var staticRenderFns = []

export { render, staticRenderFns }